/* ========================================================================
 *  module feedback
 * ========================================================================
*/
FD.PROJECTADD = (function ($, me) {
    'use strict';

    var child = me.PROJECTADD || {};


    /* ========================================================================
     *  vars
     * ========================================================================
    */
    var URL_PROJECTS = '/Projects/Modules/';

    var MESSAGE_CONTAINER_ELEM = '[data-modalmessage="true"]';
    var MODAL_ELEM = '#PROJECTADD_MODAL';
    var MONTHLY_WARNING = '#MONTHLY_WARNING';

    var notify = new Notify();
    var label = null;
    var modal;
    var accountEntityType = 29;

    var projectOptions = {};

    var defaults = {
        showEdit: false,
        showAdd: false,
        showLink: false,
        linkMultiple: false,
        entityID: null,
        metricAccountList: null,
        addCallback: null,
        linkCallback: null,
        entityList: []
    };

    var entityTypeEnum = {
        Cell: 2,
        SC: 35
    };

    var inputParams = {};

    var newProjectID = -1;
    var projectList = [];
    var currentEntityType = -1;

    /* ========================================================================
     *  tags
     * ========================================================================
    */

    var tag = {
        // Add Projects
        SELECT_RELATEDENTITY: 10,
        SAVE_BTN: 11,
        ENTITY_OWNER: 12,
        PRIORITY: 15,
        IsTop50: 13,
        Top50Category: 14,
        SAVE_EXIT_BTN: 16,

        // Link Projects
        SELECT_FILTER: 20,
        SEARCH: 21,
        SHOW_COMPLETED: 22,
        LINK_PROJECT: 23,

        //Linking and Creating Jobs
        CREATE_JOB: 27,

        // Switching Tabs
        TAB_LINK: 30,
        TAB_ADD: 31
    };


    /* 
     * ========================================================================
     *  Objects
     * ========================================================================
    */


    // create a project object
    function setProjectItem() {
        return {
            ProjectTitle: null,
            OwnerID: null,
            EntityID: null,
            AccountID: null,
            StartDate: null,
            EndDate: null,
            AnnualValue: null,
            CurrencyType: null,
            JobID: null,
            ProjectScope: null,
            DefinitionOfDone: null,
            IsTop50: null,
            Top50Category: null,
            EstimatedHours: null,
            Custom: null,
        };
    }


    /* 
     * ========================================================================
     *  CRUD Functions
     * ========================================================================
    */


    // validate new project
    function setSaveButton(data) {
        if (me.CONTROL.Validate(MODAL_ELEM)) {
            var frmElem = me.getFormFields(MODAL_ELEM);
            var item = setProjectItem();
            item = $.extend({}, item, frmElem);
            if (!item.IsTop50) {
                item.Top50Category = null;
            }

            handleProjectAddCRUD(item);
        }
    }


    // submit new project to server
    function handleProjectAddCRUD(item) {
        var options = {
            url: URL_PROJECTS + "HandleProjectAddCRUD",
            params: {
                item: item,
                showEdit: projectOptions.showEdit
            },
            callback: afterData,
            isloader: true
        };

        me.AJAX.setAJAX(options);

        function afterData(result) {
            if (result.data && result.data > 0) {
                newProjectID = result.data;
                if (projectOptions.addCallback && typeof projectOptions.addCallback === 'function') {
                    projectOptions.addCallback(result);
                }
                $(MODAL_ELEM).modal('hide');
            }
        }
    }


    // Link a project
    function handleLinkProject(data) {
        newProjectID = +data.parentid;
        if (projectOptions.linkMultiple) {
            projectList.push(newProjectID);
        } else {
            projectList = [newProjectID];
        }

        // Call provided update function
        if (projectOptions.linkCallback && typeof projectOptions.linkCallback === 'function') {
            projectOptions.linkCallback(newProjectID);
        }

        // If you can only link a single project, just close the modal aftewards
        // If you can link multiple projects, check to see if we're out of projects before
        // trying to update the list via JavaScript alone
        if (!projectOptions.linkMultiple) {
            $(MODAL_ELEM).modal('hide');
        } else if ($(MODAL_ELEM).find('tr').length < 3) {
            getLinkProjectList(true);
        } else {
            data.e.closest('tr').remove();
            var rows = $(MODAL_ELEM).find('.row-counter');
            for (var x = 1; x <= rows.length; x++) {
                rows[x - 1].innerHTML = x;
            }
        }
    }


    /* 
     * ========================================================================
     *  Views/Partial Views
     * ========================================================================
    */


    //  load modal
    function getAddProjectModal() {
        label = label || me.getLabel();
        var options = {
            params: {
                options: projectOptions
            },
            url: URL_PROJECTS + 'GetAddProjectModal',
            callback: afterData,
            cancelprevious: true,
            isloader: true
        };
        me.AJAX.setAJAX(options);

        function afterData(data) {
            var result = data.data;

            $('body').append(result.HTML);
            inputParams = result.InputParams;

            modal = $(MODAL_ELEM);

            modal.on('shown.bs.modal', function () {
                $('[data-fldname="ProjectTitle"]').focus();
                if (projectOptions.showLink) {
                    getLinkProjectList();
                }
            }).on('hidden.bs.modal', function () {
                handleAddProjectModalCleanup();
            }).modal('show').enableControls();
        }
    }


    function getCreateJobModal(projectTitle) {
        $(MODAL_ELEM).off('hidden.bs.modal').on('hidden.bs.modal', function () {
            me.TIMETRACKER.getCreateJobModal({
                addCallback: placeNewJobInProjectModule,
                hideCallback: showProjectModule,
                initialTitle: projectTitle
            });
        }).modal('hide');
    }


    function placeNewJobInProjectModule(callBackData) {
        var options = {
            url: URL_PROJECTS + "ReturnJobByID",
            params: {
                jobID: callBackData.NewJobID
            },
            callback: afterData
        };

        me.AJAX.setAJAX(options);

        function afterData(result) {
            if (result.data) {
                $(MODAL_ELEM + ' [data-fldname="JobID"]').data({
                    value: callBackData.NewJobID,
                    initial: result.data.JobName
                }).attr({
                    'data-value': callBackData.NewJobID,
                    'data-initial': result.data.JobName
                }).val(result.data.JobName);
            }
        }
    }


    // Update input params based on user action
    function setProjectSearch(data) {
        switch (data.tag) {
            case tag.SELECT_FILTER:
                inputParams.FilterID = data.value;
                break;
            case tag.SEARCH:
                inputParams.SearchTerm = data.value;
                break;
            case tag.SHOW_COMPLETED:
                inputParams.StatusType = data.value;
                break;
        }

        getLinkProjectList();
    }


    // Refresh list of projects
    function getLinkProjectList() {
        var options = {
            url: URL_PROJECTS + "GetLinkProjectList",
            params: {
                inputParams: inputParams,
                linkedProjects: projectList
            },
            callback: afterData,
            ishtml: true,
            cancelPrevious: true,
            delay: true,
            isloader: true
        };

        me.AJAX.setAJAX(options);

        function afterData(data) {
            var result = data.data;
            $('#PROJADD_PROJECTLIST').html(result);
            me.CONTROL.setButton(true, MODAL_ELEM);
            me.CONTROL.setStatus(true, MODAL_ELEM);
        }
    }



    /*
    * ========================================================================
    * Helper Functions
    * ========================================================================
    */


    function toggleSaveButton(data) {
        if (data.tag === tag.TAB_ADD) {
            $(MODAL_ELEM + ' [data-tag="' + tag.SAVE_BTN + '"]').removeClass('hidden');
            $(MODAL_ELEM + ' [data-tag="' + tag.SAVE_EXIT_BTN + '"]').removeClass('hidden');
        } else {
            $(MODAL_ELEM + ' [data-tag="' + tag.SAVE_BTN + '"]').addClass('hidden');
            $(MODAL_ELEM + ' [data-tag="' + tag.SAVE_EXIT_BTN + '"]').addClass('hidden');
        }
    }


    // show/hide annual value fields based on whether the user selected an account or monthly metric for the related entity
    function selectRelatedEntity(data) {
        if (+data.e.find('option:selected').data('entitytype') === accountEntityType) {
            $(MODAL_ELEM + ' [data-annualvalue]').removeClass('hidden');
        } else {
            $(MODAL_ELEM + ' [data-annualvalue]').addClass('hidden');
        }
    }


    // If the selected entity is a super cell, we need to display the monthly scoring warning message
    function validateEntityType(data) {
        var annualValue = $(MODAL_ELEM + ' [data-fldname="AnnualValue"]').val();
        var selectedEntityType;
        if (annualValue && Number(annualValue) > 0 && selectedEntityType !== entityTypeEnum.Cell) {
            $(MODAL_ELEM + ' [data-fldname="EntityID"]').data({
                value: data.e.data("initialValue"),
                initial: data.initial
            }).attr({
                'data-value': data.e.data("initialValue"),
                'data-initial': data.initial
            }).val(data.initial);

            notify.alert(label["PleaseSelectCellOrSetAnnualToZero"]);

            return;
        }

        currentEntityType = selectedEntityType;
        $(MODAL_ELEM + ' [data-fldname="EntityID"]').data("initialValue", data.value);
        $(MONTHLY_WARNING).toggleClass('hidden', selectedEntityType !== entityTypeEnum.SC);
    }

    function displayTopCategory(data) {
        $(MODAL_ELEM + ' [data-top50category]').toggleClass('hidden', !data.value);
        $(MODAL_ELEM + ' [data-blank]').toggleClass('hidden', data.value);
        if (!data.value) {
            $(MODAL_ELEM).find('[data-tag="' + tag.Top50Category + '"]', PROJECTADD_MODAL).val(-1);
        }

    }



    function handleAddProjectModalCleanup() {
        me.setToolTip();
        $(MODAL_ELEM).remove();
        if (projectOptions.showEdit && newProjectID > 0) {
            me.PROJECTEDIT.loadEditProjectModal(newProjectID, projectOptions.addCallback);
        }
        newProjectID = -1;
        projectList = [];
    }


    function showProjectModule() {
        $(MODAL_ELEM).off('hidden.bs.modal').on('hidden.bs.modal', function () {
            handleAddProjectModalCleanup();
        }).modal('show');
    }

    /* ========================================================================
     *  page init
     * ========================================================================
    */


    child.init = function () { };

    // Display add project modal
    // options: add project modal options
    // projectIDList: If options.showLink == true, this list will be used to determine what projects have already been linked. This parameter is ignored if options.showLink == false
    child.loadAddProjectModal = function (options, projectIDList) {
        projectOptions = $.extend({}, defaults, options);
        if (projectIDList) {
            for (var x = 0; x < projectIDList.length; x++) {
                projectList.push(projectIDList[x]);
            }
        }
        getAddProjectModal();
    };


    //   after control event
    child.getAfterControlEvent = function (data) {
        var result = data;
        // save button
        if (result.tag === tag.SAVE_BTN) {
            projectOptions.showEdit = true;
            setSaveButton(result);
        }
        else if (result.tag === tag.SAVE_EXIT_BTN) {
            projectOptions.showEdit = false;
            setSaveButton(result);
        }

        else if (result.tag === tag.CREATE_JOB) {
            getCreateJobModal($(MODAL_ELEM + ' [data-fldname="ProjectTitle"]').val());
        }

        // select related entity and show/hide annual value fields
        else if (result.tag === tag.SELECT_RELATEDENTITY) selectRelatedEntity(result);

        // check to see if the selected entity is a super cell
        else if (result.tag === tag.ENTITY_OWNER) validateEntityType(result);
        else if (result.tag === tag.IsTop50) displayTopCategory(result);

        // Linked project functionality
        else if (result.tag === tag.SEARCH ||
            result.tag === tag.SELECT_FILTER ||
            result.tag === tag.SHOW_COMPLETED) setProjectSearch(result);
        else if (result.tag === tag.LINK_PROJECT) handleLinkProject(result);

        // Show/Hide "Save" button
        else if (result.tag === tag.TAB_ADD ||
            result.tag === tag.TAB_LINK) toggleSaveButton(result);
    };

    return child;
}(jQuery, FD));



